

import React from 'react';
import { FaChevronDown } from 'react-icons/fa'; 

const AccordionItem = ({ index, title, description, videoId, isOpen, onToggle }) => {

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    // Dependemos 100% de 'Accordion.css'
    <div className="accordion-item">
      
      {/* 1. EL HEADER (BOTÓN) */}
      <div 
        className={`accordion-header ${isOpen ? 'open' : ''}`}
        onClick={() => onToggle(index)} // <-- Llama al padre
      >
        <h5>{title}</h5>
        <FaChevronDown className="accordion-icon" /> {/* <-- Usa el ícono */}
      </div>

      {/* 2. EL CUERPO (CONTENIDO) */}
      {/* Usa la prop 'isOpen' del padre */}
      <div className={`accordion-body ${isOpen ? 'open' : ''}`}>
        
        <div>
           {/* <-- Muestra la descripción */}
          <p className="video-description">
            {description}
          </p>

          <div className="video-responsive-wrapper">
            <iframe
              src={embedUrl}
              title={title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;